<script lang="ts">
    import { MenuBar as MenuBarComp } from "../../../../svelte-editor-layout";
    import { COMMANDS, MENU } from "$lib/commands";
    import { file } from "$lib/state";
    import FileInfoDropdown from "$lib/panels/FileInfoDropdown.svelte";
    import { onMount } from "svelte";
    import type { File, FileMetadata } from "$lib/wasm/file";

    let metadata: FileMetadata | null = null;
    let activeFile: File | null = null;

    function updateMetadata() {
        metadata = activeFile?.getMetadata() ?? null;
    }

    onMount(() => {
        let eventSubscriptions: { unsubscribe: () => void }[] = [];

        const unsubscribeFile = file.subscribe(($file) => {
            eventSubscriptions.forEach((subscription) => subscription.unsubscribe());
            eventSubscriptions = [];

            activeFile = $file;
            updateMetadata();

            if (!$file) return;

            eventSubscriptions = [
                $file.onDataChanged.subscribe(updateMetadata),
                $file.onFramesChanged.subscribe(updateMetadata),
                $file.onLayersChanged.subscribe(updateMetadata),
                $file.onHistoryChanged.subscribe(updateMetadata),
                $file.onSave.subscribe(updateMetadata),
            ];
        });

        return () => {
            eventSubscriptions.forEach((subscription) => subscription.unsubscribe());
            unsubscribeFile();
        };
    });
</script>

<!----------------------------------------------------------------------------->

<div class="menubar">
    <MenuBarComp items={MENU} />
    <div class="title">
        {#if $file}
            <button
                class="name"
                data-testid="active-file-name"
                on:click={() => COMMANDS.commands["file.rename"].invoke()}
                title="Rename file"
            >
                {$file.name}
            </button>
            <span class="separator">·</span>
            <FileInfoDropdown {metadata} />
        {/if}
    </div>
</div>

<!----------------------------------------------------------------------------->

<style>
    .menubar {
        display: grid;
        grid-template-columns: 1fr minmax(0, max-content) minmax(0, 1fr);
        align-items: center;
    }

    .title {
        min-width: 0;
        display: flex;
        align-items: center;
        gap: 0.35em;
        justify-content: center;
        white-space: nowrap;
    }

    .name {
        all: unset;
        cursor: pointer;
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        border-radius: 0.25em;
        padding: 0 0.25em;
    }

    .name:hover,
    .name:focus-visible {
        color: var(--tacc);
        background: var(--g200);
    }

    .separator {
        color: var(--t400);
    }
</style>
